export default __webpack_public_path__ + "static/media/why1.f62dd3a9.svg";